export default "__VITE_ASSET__5935d061__"